import api from '../../utils/api';
import { alertError } from './alert';
import {
  PRODUCT_FEEDS_DATA,
  PRODUCT_FEEDS_LOADING,
  PRODUCT_FEEDS_PAGE,
  PRODUCT_FEEDS_ROWS_PER_PAGE,
  PRODUCT_FEEDS_TOTAL_COUNT,
} from '../reducers/productsFeeds';
import { getTotalCountHeader } from './api/utils';

const setProductsFeedsLoading = (isLoading = true) => ({ type: PRODUCT_FEEDS_LOADING, payload: isLoading });
const setProductsFeedsData = (data) => ({ type: PRODUCT_FEEDS_DATA, payload: data });
const setProductsFeedsTotalCount = (count) => ({ type: PRODUCT_FEEDS_TOTAL_COUNT, payload: count });
export const setProductsFeedsPage = (page) => ({ type: PRODUCT_FEEDS_PAGE, payload: page });
export const setProductsFeedsRowsPerPage = (rows) => ({ type: PRODUCT_FEEDS_ROWS_PER_PAGE, payload: rows });

export const fetchProductsFeeds = () => async (dispatch, getState) => {
  dispatch(setProductsFeedsLoading());
  try {
    const { supplierId } = getState().role;
    const tableParams = getState().productsFeeds.table;
    const params = new URLSearchParams({
      limit: tableParams.rowsPerPage,
      page: tableParams.page + 1,
    });
    const response = await api.get(`/suppliers/${supplierId}/product-feeds`, { params });

    if (response?.status === 200) {
      dispatch(setProductsFeedsData(response.data));

      const totalCount = getTotalCountHeader(response);
      dispatch(setProductsFeedsTotalCount(totalCount));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};
